import React, { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "../../css/TestimonialSlider.css";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = `${BASE_URL}getpagedata/get_feedbacks.php`;

export default function TestimonialSlider() {

  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ================= FETCH FEEDBACKS ================= */
  useEffect(() => {
    fetchFeedbacks();
  }, []);

  const fetchFeedbacks = async () => {
    try {
      const res = await axios.get(API_URL);

      if (res.data.success) {
        setTestimonials(res.data.data);
      }
    } catch (error) {
      console.error("Error loading testimonials:", error);
    } finally {
      setLoading(false);
    }
  };

  /* ================= RENDER ================= */
  if (loading) {
    return (
      <div className="section z-bigger text-center py-5">
        Loading testimonials...
      </div>
    );
  }

  if (testimonials.length === 0) {
    return null; // hide section if no feedbacks
  }

  return (
    <div className="section z-bigger">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8">

            <Swiper
              slidesPerView={1}
              loop={true}
              autoplay={{ delay: 3500, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              modules={[Autoplay, Pagination]}
              className="testimonial-swiper"
            >
              {testimonials.map((item) => (
                <SwiperSlide key={item.fid}>
                  <div className="quote-sep text-center">
                    <h4>"{item.comments}"</h4>
                    <h6>— {item.author}</h6>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

          </div>
        </div>
      </div>
    </div>
  );
}